import axios from '../index'

export function createLinkRecommendation(data, opts = {}) {
  return axios.post('/ajax/clients/link_recommendations', data, opts)
}

export function requestAdvancedReport(data, opts = {}) {
  return axios.post(`/ajax/clients/link_recommendations/${data.id}/request_advanced_report`, data, opts)
}

export function getLinkRecommendation(data, opts = {}) {
  return axios.get(`/ajax/clients/link_recommendations/${data.id}?silence_analytics=${data.silenceAnalytics}`, data, opts)
}

